import axios from 'axios';
import backendURL from './backend'

const api = axios.create({baseURL: backendURL,});

// Handler injectado pelo JWTContext para integrar 401 com o estado React (logout + redirect via AuthGuard).
let onUnauthorized = null;

export const setupAuthInterceptor = (handler) => {
  onUnauthorized = handler;
};

// Intercept 401 responses globally to redirect to login on session expiry
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('serviceToken');
      delete api.defaults.headers.common.Authorization;
      // Notifica o JWTContext para fazer dispatch(LOGOUT) — assim o AuthGuard redireciona
      // sem deixar componentes a renderizar com dados nulos (que causava a página em branco).
      if (typeof onUnauthorized === 'function') {
        try { onUnauthorized(); } catch (e) { /* noop */ }
      }
      // Rede de segurança: se por algum motivo o estado React não desmontar a página,
      // forçar o redirect via browser.
      if (window.location.pathname !== '/auth/signin-1') {
        window.location.replace('/auth/signin-1');
      }
    }
    return Promise.reject(error);
  }
);

export default api;